import { render, staticRenderFns } from "./About.vue?vue&type=template&id=2e17bb94"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=2e17bb94&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports